module.exports = __webpack_public_path__ + "static/img/img-educator-feature-3-m@2x.a6ded01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-3-m@2x.png
// module id = pswL
// module chunks = 18